import React, { useState, useContext, useEffect } from 'react'
import classNames from 'classnames'
import styles from './ResumeWidget.module.scss'
import GeoContext from '../../../utils/geoContext'

const ResumeWidget = ({ slug }) => {
  const [showCV, setShowCV] = useState(null)
  const countryData = useContext(GeoContext)

  useEffect(() => {
    const gulfCountryCodes = [
      { code: 'BH', country: 'Bahrain' },
      { code: 'IQ', country: 'Iraq' },
      { code: 'KW', country: 'Kuwait' },
      { code: 'OM', country: 'Oman' }, 
      { code: 'QA', country: 'Qatar' },
      { code: 'SA', country: 'Saudi Arabia' },
      { code: 'AE', country: 'United Arab Emirates' },
    ]

    const cvCountries = [
      { code: 'GB', country: 'United Kingdom' },
      { code: 'IR', country: 'Ireland' },
      ...gulfCountryCodes,
    ]

    if (countryData) {
      setShowCV(
        cvCountries
          .map((country) => country.code)
          .includes(countryData?.geo?.country_code),
      )
    } else {
      // fetch fails
      setShowCV(null)
    }
  }, [countryData])

  return (
    <div className="w-100">
      <div className={classNames(styles.sidebar, 'shadow-sm')}>
        <div className={styles.sidebarHeader}>
          How strong is your{' '}
          {showCV === null ? 'CV/Resume' : showCV ? 'CV' : 'Resume'} ?
        </div>

        <div className={styles.form}>
          <p>
            Have a free 15 minute CV review call with an expert CV writer thanks
            to our partners at The CV Centre.
          </p>
          <input type="hidden" name="form-name" value="cvreview" />
          <input
            type="hidden"
            name="country"
            value={countryData?.geo?.country_code}
          />

          <input type="hidden" name="articleSlug" value={slug} />
          <input type="hidden" name="city" value={countryData?.geo?.city} />

          <a
            className="btn btn-orange w-100"
            href="https://link.wikijob.co.uk/cv-free-review?utm_campaign=right-side-banner"
            rel="sponsored nofollow"
            target="blank"
          >
            Get a Free Review
          </a>
        </div>
      </div>
    </div>
  )
}

export default ResumeWidget
